import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { pathEq } from 'ramda'

import UserSlide from './user-slide'
import { dataLayerProductClick } from '../../../lib/analytics/datalayer'
import { setTrailerLaunchedFromComponent } from '../../../actions/index'
import HOTSPOT_SLIDE_FRAGMENT from '../../../../graphql/fragments/hotspot-slide.gql'
import useInitializeCastSender from '../../../hooks/use-initialize-cast-sender'
import { useConfig } from '../../../hooks/use-config'
import { useUsableOnClick } from '../hooks/use-usable-on-click'

const HotspotSlide = ({
  slide,
  isContentItemOnMyList,
  addToMyList,
  hasTopgradient,
  isGuestHome,
  index,
  className,
  isSlideSelected,
  isTrailerMuted,
  setTrailerMuted,
  onTrailerLoaded,
  onTrailerEnded,
  trailerAutoplayEnabled,
  isAuthenticated
}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { appConfig, configLoading } = useConfig()

  const { castSender, maybeInitializeCastSender } = useInitializeCastSender()

  const { contentItem } = slide

  const onCtaClick = useCallback(
    (url) => {
      dataLayerProductClick(contentItem, index, 'Hotspot', window.location.pathname)

      if (pathEq(['__typename'], 'VideoExtra', contentItem)) {
        maybeInitializeCastSender(url, contentItem, true)
        if (!castSender?.isConnected) {
          dispatch(setTrailerLaunchedFromComponent(true))
        }
      } else {
        history.push(url)
      }
    },
    [contentItem, index, maybeInitializeCastSender, castSender, dispatch, history]
  )

  const usableOnClick = useUsableOnClick()

  // Guest slides need config before the background image can be rendered.
  if (isGuestHome && (configLoading || !appConfig?.values)) {
    return null
  }

  return (
    <UserSlide
      slide={slide}
      isOnMyList={isContentItemOnMyList(contentItem.id)}
      addToMyList={addToMyList}
      hasTopgradient={hasTopgradient}
      onCtaClick={onCtaClick}
      usableOnClick={usableOnClick}
      isAuthenticated={isAuthenticated}
      appConfig={appConfig}
      isGuestHome={isGuestHome}
      className={className}
      isSlideSelected={isSlideSelected}
      isTrailerMuted={isTrailerMuted}
      setTrailerMuted={setTrailerMuted}
      onTrailerLoaded={onTrailerLoaded}
      onTrailerEnded={onTrailerEnded}
      trailerAutoplayEnabled={trailerAutoplayEnabled}
    />
  )
}

HotspotSlide.propTypes = {
  slide: propType(HOTSPOT_SLIDE_FRAGMENT).isRequired,
  isContentItemOnMyList: PropTypes.func.isRequired,
  addToMyList: PropTypes.func.isRequired,
  hasTopgradient: PropTypes.bool.isRequired,
  isGuestHome: PropTypes.bool.isRequired,
  index: PropTypes.number,
  className: PropTypes.string,
  isSlideSelected: PropTypes.bool.isRequired,
  isTrailerMuted: PropTypes.bool.isRequired,
  setTrailerMuted: PropTypes.func.isRequired,
  onTrailerLoaded: PropTypes.func.isRequired,
  onTrailerEnded: PropTypes.func.isRequired,
  trailerAutoplayEnabled: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
}

HotspotSlide.defaultProps = {
  index: 0,
  className: null
}

export default HotspotSlide
